import React, { memo, useEffect, useState } from 'react';
import Autocomplete from '../../../shared/components/Autocomplete';
import { useCallback } from 'react';

const AutoCompleteDevices = ({
    getTypingSimcardsRequest,
    getSimcardsStatusesRequest,
    setStateSimcards,
    sicmards: { fetching, simCards, statuses, statuesFetching },
    simcardValue,
    handleSimcard,
    placeholder,
    defaultOptions = null,
    label,
    gps: { gps_device },
    ...props
}) => {
    const [options, setOptions] = useState([{ ...defaultOptions }]);
    const [statusAssignedToGps, setStatusAssignedToGps] = useState(null);

    const handleSearchSimcard = value => {
        const filters = {
            limit: 20,
            iccid: value,
            'status!': statusAssignedToGps
        };

        if (value && typeof value === 'string' && value.length) {
            setStateSimcards({ simCards: [] });
            getTypingSimcardsRequest(filters);
        }
    };

    const handleClearSimcards = useCallback(() => {
        setStateSimcards({ simCards: [] });
        setOptions([{ ...defaultOptions }]);
    }, [setStateSimcards, defaultOptions]);

    useEffect(() => {
        if (simCards.length) {
            setOptions([
                { ...defaultOptions },
                ...simCards.map(device => ({
                    label: device.iccid,
                    value: device._id
                }))
            ]);
        }
    }, [simCards, defaultOptions]);

    useEffect(() => {
        if(gps_device.simcard !== undefined){
        getSimcardsStatusesRequest();
    }
    }, [getSimcardsStatusesRequest]);

    useEffect(() => {
        if (statuses.length) {
            const statusAssignedToGps = statuses.find(st => st.code === 'asignado_a_gps');
            setStatusAssignedToGps(statusAssignedToGps._id);
        }
    }, [statuses]);

    return (
        <Autocomplete
            value={simcardValue}
            onChange={handleSimcard}
            placeholder={placeholder}
            label={label}
            loading={fetching || statuesFetching}
            options={options}
            onInputChangeAction={handleSearchSimcard}
            isDisabled={false}
            resetAction={handleClearSimcards}
            {...props}
        />
    );
};

export default memo(AutoCompleteDevices);
